import { render, staticRenderFns } from "./RcvD_Return.vue?vue&type=template&id=b364a510"
import script from "./RcvD_Return.vue?vue&type=script&lang=js"
export * from "./RcvD_Return.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports